import { render, staticRenderFns } from "./QuotationPackages.vue?vue&type=template&id=76d8847b&scoped=true&"
import script from "./QuotationPackages.vue?vue&type=script&lang=js&"
export * from "./QuotationPackages.vue?vue&type=script&lang=js&"
import style0 from "./QuotationPackages.vue?vue&type=style&index=0&id=76d8847b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d8847b",
  null
  
)

export default component.exports